import React from 'react';
import Component from '@vfuk/core-text-input-with-label';
const TextInputWithLabel = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default TextInputWithLabel;
